export var ALIGNMENTS = ['top', 'bottom', 'start', 'end', 'center'];
export var POSITIONS = ['above', 'below', 'before', 'after'];
//# sourceMappingURL=types.internal.js.map
